import { render, staticRenderFns } from "./CardsList.vue?vue&type=template&id=6dbc1edd&scoped=true&"
import script from "./CardsList.vue?vue&type=script&lang=js&"
export * from "./CardsList.vue?vue&type=script&lang=js&"
import style0 from "./CardsList.vue?vue&type=style&index=0&id=6dbc1edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc1edd",
  null
  
)

export default component.exports